import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { CreateAccountResponse, CreateAccountRequest } from "api/models";
import { FORM_ERROR } from "final-form";
import { FormProps } from "react-final-form";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { Routes } from "config/navigation";
import { postCreateAccount } from "../../api";
import { CreateAccountValues } from "../../types";
import { setLoginUserDataToLocalStorage, setUserDataToCookies } from "../../utils";

export const useCreateAccountMutation = (key?: string) => {
  const navigate = useNavigate();

  const { mutateAsync } = useMutation<
    CreateAccountResponse,
    AxiosError<{ message: string }>,
    CreateAccountRequest
  >(postCreateAccount);

  const execute: FormProps<CreateAccountValues, CreateAccountValues>["onSubmit"] = useCallback(
    async (values) => {
      try {
        const res = await mutateAsync({
          ...values,
          key: key ?? "",
          remember: false
        });

        setLoginUserDataToLocalStorage(res);

        setUserDataToCookies(false, res.data.shopId);

        navigate(Routes.CREATE_ACCOUNT_ONBOARDING);
      } catch (err) {
        const error = err as AxiosError<{ message: string }>;

        let errorTranslationKey = "global.error.serverUnavailable";

        if (error.response?.data.message) {
          errorTranslationKey = error.response?.data.message;
        }

        if (error.response?.status === 409) {
          errorTranslationKey = "authModule.errors.emailAlreadyExist";
        }

        return {
          [FORM_ERROR]: errorTranslationKey
        };
      }
    },
    [key]
  );

  return execute;
};
